THEME.home= {
  init: function() { 
  
	/* ================================
	===       SLIDERS              ====
	=================================== */
	function owl_slider_block_all(e){
		jQuery('#block--all .owl-carousel').owlCarousel({
		    loop:true,
		    margin:10,
		    nav:true,
		    navText:["<i class='ion-ios-arrow-back'></i>","<i class='ion-ios-arrow-forward'></i>"],
		    responsiveClass:true,
		    responsive:{
		        0:{
		            items:1,
		            nav:true,
		            loop:true,
		    		margin:0
		        }
		    }
		});
	}
	function owl_slider_block_highlights(e){
		jQuery('#block--highlights .owl-carousel').owlCarousel({
			loop:true,
		    margin:10,
		    nav:true,
		    navText:["<i class='ion-ios-arrow-back'></i>","<i class='ion-ios-arrow-forward'></i>"],
		    responsiveClass:true,
		    responsive:{
		    	0:{
		            items:1,
		    		nav:true,
		            loop:true,
		    		margin:0
		        },
		        736:{
		            items:3,
    				center: true,
		    		nav:true,
		            loop:true
		        },
		        996:{
		            items:4,
		    		nav:true,
		            loop:true
		        }
		    }
		});
	}
	function split_operators_list(){
		var
	    container = jQuery('.list_operator'),
	    num_cols = jQuery('.list_operator').data('cols'),
	    listItem = 'li',
	    listClass = 'sub-list';
	    container.each(function() {
	        var items_per_col = [],
	        items = jQuery(this).find(listItem),
	        min_items_per_col = Math.floor(items.length / num_cols),
	        difference = items.length - (min_items_per_col * num_cols);
	        for (var i = 0; i < num_cols; i++) {
	            if (i < difference) {
	                items_per_col[i] = min_items_per_col + 1;
	            } else {
	                items_per_col[i] = min_items_per_col;
	            }
	        }
	        for (var h = 0; h < num_cols; h++) {
	            jQuery(this).append(jQuery('<ul ></ul>').addClass(listClass));
	            for (var j = 0; j < items_per_col[h]; j++) {
	                var pointer = 0;
	                for (var k = 0; k < h; k++) {
	                    pointer += items_per_col[k];
	                }
	                jQuery(this).find('.' + listClass).last().append(items[j + pointer]);
	            }
	        }
	    }).parent().addClass('splitted');
	}
	/* == DOCUMENT READY ==================================================================================== */
    owl_slider_block_all(); /* === SLIDERS === */
    owl_slider_block_highlights(); /* === SLIDERS === */
    split_operators_list(); /* === SLIDERS === */
	/* == DOCUMENT READY END ================================================================================ */
	
	/* == Click ==================================================================================== */
	/* == Click END ================================================================================ */

	/* == WINDOW RESIZE ===================================================================================== */
		$themeWin.resize(function() {
			// calculateSlider();
		});
	/* == WINDOW RESIZE END ================================================================================= */
	/* == WINDOW scroll ===================================================================================== */
		$themeWin.scroll(function() {
			// calculateSlider();
		});
	/* == WINDOW scroll END ================================================================================= */
  },
  finalize: function() { }
};
